import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
// Copyright 2018 Consensys AG
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
function inMemoryCache() {
  var cache = new Map();
  return function (parsed, resolve) {
    try {
      var _temp2 = function _temp2(_result) {
        if (_exit) return _result;
        var cached = cache.get(parsed.didUrl);
        return cached !== undefined ? cached : Promise.resolve(resolve()).then(function (result) {
          var _result$didResolution;
          if (((_result$didResolution = result.didResolutionMetadata) == null ? void 0 : _result$didResolution.error) !== 'notFound') {
            cache.set(parsed.didUrl, result);
          }
          return result;
        });
      };
      var _exit;
      var _temp = function () {
        if (parsed.params && parsed.params['no-cache'] === 'true') {
          return Promise.resolve(resolve()).then(function (_await$resolve) {
            _exit = 1;
            return _await$resolve;
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function noCache(parsed, resolve) {
  return resolve();
}
var PCT_ENCODED = '(?:%[0-9a-fA-F]{2})';
var ID_CHAR = "(?:[a-zA-Z0-9._-]|".concat(PCT_ENCODED, ")");
var METHOD = '([a-z0-9]+)';
var METHOD_ID = "((?:".concat(ID_CHAR, "*:)*(").concat(ID_CHAR, "+))");
var PARAM_CHAR = '[a-zA-Z0-9_.:%-]';
var PARAM = ";".concat(PARAM_CHAR, "+=").concat(PARAM_CHAR, "*");
var PARAMS = "((".concat(PARAM, ")*)");
var PATH = "(/[^#?]*)?";
var QUERY = "([?][^#]*)?";
var FRAGMENT = "(#.*)?";
var DID_MATCHER = new RegExp("^did:".concat(METHOD, ":").concat(METHOD_ID).concat(PARAMS).concat(PATH).concat(QUERY).concat(FRAGMENT, "$"));
function parse(didUrl) {
  if (didUrl === '' || !didUrl) return null;
  var sections = didUrl.match(DID_MATCHER);
  if (sections) {
    var parts = {
      did: "did:".concat(sections[1], ":").concat(sections[2]),
      method: sections[1],
      id: sections[2],
      didUrl: didUrl
    };
    if (sections[4]) {
      var params = sections[4].slice(1).split(';');
      parts.params = {};
      var _iterator = _createForOfIteratorHelper(params),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          var kv = p.split('=');
          parts.params[kv[0]] = kv[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (sections[6]) parts.path = sections[6];
    if (sections[7]) parts.query = sections[7].slice(1);
    if (sections[8]) parts.fragment = sections[8].slice(1);
    return parts;
  }
  return null;
}
var EMPTY_RESULT = {
  didResolutionMetadata: {},
  didDocument: null,
  didDocumentMetadata: {}
};
function wrapLegacyResolver(resolve) {
  return function (did, parsed, resolver) {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(resolve(did, parsed, resolver)).then(function (doc) {
          return _objectSpread(_objectSpread({}, EMPTY_RESULT), {}, {
            didResolutionMetadata: {
              contentType: 'application/did+ld+json'
            },
            didDocument: doc
          }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        });
      }, function (e) {
        return _objectSpread(_objectSpread({}, EMPTY_RESULT), {}, {
          didResolutionMetadata: {
            error: 'notFound',
            message: e.toString() // This is not in spec, but may be helpful
          }
        });
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var Resolver = /*#__PURE__*/function () {
  function Resolver() {
    var _this2 = this;
    var registry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Resolver);
    this.registry = void 0;
    this.cache = void 0;
    this.registry = registry;
    this.cache = options.cache === true ? inMemoryCache() : options.cache || noCache;
    if (options.legacyResolvers) {
      Object.keys(options.legacyResolvers).map(function (methodName) {
        if (!_this2.registry[methodName]) {
          _this2.registry[methodName] = wrapLegacyResolver(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          options.legacyResolvers[methodName]);
        }
      });
    }
  }
  _createClass(Resolver, [{
    key: "resolve",
    value: function resolve(didUrl) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        var _this = this;
        var parsed = parse(didUrl);
        if (parsed === null) {
          return Promise.resolve(_objectSpread(_objectSpread({}, EMPTY_RESULT), {}, {
            didResolutionMetadata: {
              error: 'invalidDid'
            }
          }));
        }
        var resolver = _this.registry[parsed.method];
        if (!resolver) {
          return Promise.resolve(_objectSpread(_objectSpread({}, EMPTY_RESULT), {}, {
            didResolutionMetadata: {
              error: 'unsupportedDidMethod'
            }
          }));
        }
        return Promise.resolve(_this.cache(parsed, function () {
          return resolver(parsed.did, parsed, _this, options);
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);
  return Resolver;
}();
export { Resolver, inMemoryCache, noCache, parse, wrapLegacyResolver };